import { useState, useEffect, useCallback } from 'react';
import { tallerService } from '../services/api';
import Navbar from '../components/Navbar';

// Devuelve el lunes y el sábado de la semana que contiene la fecha dada
function semanaLunSab(fecha) {
  const d = new Date(fecha);
  const dia = d.getDay(); // 0=domingo, 1=lunes, ... 6=sábado
  const difLunes = dia === 0 ? 6 : dia - 1;
  const lunes = new Date(d);
  lunes.setDate(d.getDate() - difLunes);
  lunes.setHours(0, 0, 0, 0);
  const sabado = new Date(lunes);
  sabado.setDate(lunes.getDate() + 5);
  return { lunes, sabado };
}

function toISO(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${dd}`;
}

export default function PagosTaller() {
  const [trabajos, setTrabajos] = useState([]);
  const [operarios, setOperarios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [semana, setSemana] = useState(() => semanaLunSab(new Date()));
  const [operarioId, setOperarioId] = useState('');
  const [montos, setMontos] = useState({}); // {trabajoId: valorEditado}
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const puedePagar = [2, 3].includes(user.id); // Felix y Pablo

  const cargar = useCallback(async () => {
    setLoading(true);
    try {
      const params = {
        desde: toISO(semana.lunes),
        hasta: toISO(semana.sabado),
      };
      if (operarioId) params.operario_id = operarioId;
      const [pag, ops] = await Promise.all([
        tallerService.pagos(params),
        tallerService.operarios(),
      ]);
      setTrabajos(pag.data || []);
      setOperarios(ops.data || []);
      setError('');
    } catch (err) {
      setError('Error al cargar los pagos');
    } finally {
      setLoading(false);
    }
  }, [semana, operarioId]);

  useEffect(() => { cargar(); }, [cargar]);

  const marcarPagado = async (id, pagado) => {
    try {
      await tallerService.marcarPagado(id, pagado);
      cargar();
    } catch (err) {
      alert(err.response?.data?.error || 'Error al marcar el pago');
    }
  };

  const guardarMonto = async (id) => {
    const valor = montos[id];
    if (valor === undefined || valor === '') { alert('Escribí un monto'); return; }
    try {
      await tallerService.fijarMonto(id, valor);
      setMontos(prev => { const n = { ...prev }; delete n[id]; return n; });
      cargar();
    } catch (err) {
      alert(err.response?.data?.error || 'Error al guardar el monto');
    }
  };

  const pagarSemanaOperario = async (items) => {
    // Solo los que tienen monto > 0 (los especiales sin monto hay que ponerles precio primero)
    const pendientes = items.filter(i => !i.pagado && Number(i.monto || 0) > 0);
    const sinMonto = items.filter(i => !i.pagado && Number(i.monto || 0) <= 0).length;
    if (pendientes.length === 0) {
      alert(sinMonto > 0 ? 'Hay trabajos sin monto. Poneles precio antes de pagar.' : 'No hay trabajos pendientes.');
      return;
    }
    let msg = `¿Marcar como pagados los ${pendientes.length} trabajos con monto de la semana?`;
    if (sinMonto > 0) msg += `\n(Quedan ${sinMonto} sin monto, hay que ponerles precio aparte.)`;
    if (!window.confirm(msg)) return;
    try {
      for (const t of pendientes) {
        await tallerService.marcarPagado(t.id, true);
      }
      cargar();
    } catch (err) {
      alert(err.response?.data?.error || 'Error al marcar la semana');
    }
  };

  const irSemana = (dir) => {
    const nuevoLunes = new Date(semana.lunes);
    nuevoLunes.setDate(nuevoLunes.getDate() + dir * 7);
    setSemana(semanaLunSab(nuevoLunes));
  };

  const esSemanaActual = () => {
    const actual = semanaLunSab(new Date());
    return toISO(actual.lunes) === toISO(semana.lunes);
  };

  const s = {
    page: { minHeight: '100vh', background: '#f5f0e8' },
    container: { maxWidth: 1000, margin: '0 auto', padding: 20 },
    card: { background: '#fff', borderRadius: 12, padding: 20, marginBottom: 16, boxShadow: '0 1px 3px rgba(0,0,0,0.1)' },
    filtros: { background: '#fff', borderRadius: 12, padding: 16, marginBottom: 16, display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between' },
    label: { display: 'block', fontSize: 12, color: '#5c3d2e', marginBottom: 4, fontWeight: 600 },
    input: { padding: 8, border: '1px solid #ccc', borderRadius: 6, fontSize: 14 },
    navBtn: { background: '#5c3d2e', color: '#fff', border: 'none', width: 40, height: 40, borderRadius: 8, cursor: 'pointer', fontSize: 18, fontWeight: 700 },
    semanaLabel: { fontSize: 16, fontWeight: 700, color: '#5c3d2e', textAlign: 'center', minWidth: 240 },
    fila: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0', borderBottom: '1px solid #f0e8e0' },
    badge: (etapa) => ({ display: 'inline-block', padding: '2px 8px', borderRadius: 10, fontSize: 11, fontWeight: 600, background: etapa === 'costura' ? '#e0e7ff' : '#fce7d4', color: etapa === 'costura' ? '#3730a3' : '#9a3412' }),
    btnPagar: { background: '#1e7e34', color: '#fff', border: 'none', padding: '5px 12px', borderRadius: 6, cursor: 'pointer', fontSize: 13 },
    btnPagarSemana: { background: '#1e7e34', color: '#fff', border: 'none', padding: '8px 16px', borderRadius: 8, cursor: 'pointer', fontSize: 14, fontWeight: 700 },
    btnMonto: { background: '#a0522d', color: '#fff', border: 'none', padding: '6px 12px', borderRadius: 6, cursor: 'pointer', fontSize: 13 },
    inputMonto: { padding: 6, border: '1px solid #a0522d', borderRadius: 6, fontSize: 14, width: 110 },
    btnDespagar: { background: '#fff', color: '#c0392b', border: '1px solid #c0392b', padding: '5px 12px', borderRadius: 6, cursor: 'pointer', fontSize: 12 },
    pagadoBadge: { display: 'inline-block', padding: '3px 10px', borderRadius: 10, fontSize: 12, fontWeight: 600, background: '#d4f4dd', color: '#1e7e34' },
  };

  const porOperario = {};
  trabajos.forEach(t => {
    if (!porOperario[t.operario_id]) porOperario[t.operario_id] = { nombre: t.operario, items: [] };
    porOperario[t.operario_id].items.push(t);
  });

  const fmtFecha = (f) => f ? new Date(f).toLocaleDateString('es-CR') : '';
  const fmt = (n) => '₡' + Number(n || 0).toLocaleString('es-CR');
  const fmtDia = (d) => d.toLocaleDateString('es-CR', { day: 'numeric', month: 'short' });

  return (
    <div style={s.page}>
      <Navbar />
      <div style={s.container}>
        <h1 style={{ color: '#5c3d2e', fontSize: 22 }}>💰 Pagos Taller</h1>
        <p style={{ color: '#8a7a6a', fontSize: 14, marginTop: -8 }}>Corte semanal (lunes a sábado). {puedePagar ? 'Marcá como pagado cuando canceles. A los especiales ponéles precio.' : '(Solo Felix y Pablo pueden marcar pagos.)'}</p>

        <div style={s.filtros}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <button style={s.navBtn} onClick={() => irSemana(-1)}>◀</button>
            <div style={s.semanaLabel}>
              Semana {fmtDia(semana.lunes)} – {fmtDia(semana.sabado)}
              {esSemanaActual() && <div style={{ fontSize: 12, color: '#1e7e34', fontWeight: 600 }}>Semana actual</div>}
            </div>
            <button style={{ ...s.navBtn, opacity: esSemanaActual() ? 0.4 : 1 }} onClick={() => irSemana(1)} disabled={esSemanaActual()}>▶</button>
          </div>
          <div>
            <label style={s.label}>Operario</label>
            <select style={s.input} value={operarioId} onChange={e => setOperarioId(e.target.value)}>
              <option value="">Todos</option>
              {operarios.map(o => <option key={o.id} value={o.id}>{o.name}</option>)}
            </select>
          </div>
        </div>

        {loading && <p>Cargando…</p>}
        {error && <p style={{ color: '#c0392b' }}>{error}</p>}
        {!loading && trabajos.length === 0 && <div style={s.card}>No hay trabajos terminados en esta semana.</div>}

        {Object.entries(porOperario).map(([opId, data]) => {
          const pendientesPago = data.items.filter(i => !i.pagado).length;
          const totalSinPagar = data.items.filter(i => !i.pagado).reduce((s, i) => s + Number(i.monto || 0), 0);
          return (
            <div key={opId} style={s.card}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                <strong style={{ color: '#5c3d2e', fontSize: 17 }}>👤 {data.nombre}</strong>
                <div style={{ textAlign: 'right' }}>
                  <div style={{ fontSize: 13, color: '#8a7a6a' }}>{data.items.length} trabajos · {pendientesPago} sin pagar</div>
                  <div style={{ fontSize: 15, fontWeight: 700, color: '#1e7e34' }}>Por pagar: {fmt(totalSinPagar)}</div>
                </div>
              </div>
              {puedePagar && pendientesPago > 0 && (
                <div style={{ marginBottom: 10 }}>
                  <button style={s.btnPagarSemana} onClick={() => pagarSemanaOperario(data.items)}>
                    ✓ Pagar toda la semana ({fmt(totalSinPagar)})
                  </button>
                </div>
              )}
              {data.items.map(t => {
                const sinMonto = Number(t.monto || 0) <= 0;
                return (
                  <div key={t.id} style={s.fila}>
                    <div>
                      <strong style={{ color: '#5c3d2e' }}>{t.numero}</strong>
                      <span style={{ ...s.badge(t.etapa), marginLeft: 8 }}>{t.etapa === 'costura' ? 'Costura' : 'Tapicería'}</span>
                      <div style={{ fontSize: 13, color: '#8a7a6a' }}>{t.articulos || '—'}</div>
                      {t.rubro && !sinMonto && <div style={{ fontSize: 13, color: '#5c3d2e', fontWeight: 600 }}>{t.rubro} · {fmt(t.monto)}</div>}
                      {sinMonto && (
                        <div style={{ fontSize: 13, color: '#a0522d', fontWeight: 600, marginTop: 4 }}>
                          {t.rubro || 'Especial'} · Sin precio
                          {puedePagar && !t.pagado && (
                            <div style={{ display: 'flex', gap: 6, marginTop: 4, alignItems: 'center' }}>
                              <span style={{ fontSize: 14 }}>₡</span>
                              <input
                                type="number"
                                placeholder="Monto"
                                style={s.inputMonto}
                                value={montos[t.id] ?? ''}
                                onChange={e => setMontos(prev => ({ ...prev, [t.id]: e.target.value }))}
                              />
                              <button style={s.btnMonto} onClick={() => guardarMonto(t.id)}>Guardar precio</button>
                            </div>
                          )}
                        </div>
                      )}
                      <div style={{ fontSize: 12, color: '#8a7a6a' }}>Terminado: {fmtFecha(t.fecha_terminado)}{t.pagado && ` · Pagado: ${fmtFecha(t.fecha_pagado)}`}</div>
                      {t.fotos && t.fotos.length > 0 && (
                        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginTop: 6 }}>
                          {t.fotos.map(f => (
                            <a key={f.id} href={"/uploads/trabajos/" + f.filename} target="_blank" rel="noreferrer">
                              <img src={"/uploads/trabajos/" + f.filename} alt="trabajo" style={{ width: 60, height: 60, objectFit: "cover", borderRadius: 6, border: "1px solid #e0d0c0" }} />
                            </a>
                          ))}
                        </div>
                      )}
                    </div>
                    <div>
                      {t.pagado
                        ? (
                          <div style={{ textAlign: 'right' }}>
                            <span style={s.pagadoBadge}>✓ Pagado</span>
                            {puedePagar && <div><button style={{ ...s.btnDespagar, marginTop: 6 }} onClick={() => marcarPagado(t.id, false)}>Deshacer</button></div>}
                          </div>
                        )
                        : (puedePagar
                          ? (sinMonto
                            ? <span style={{ fontSize: 12, color: '#a0522d' }}>Falta precio</span>
                            : <button style={s.btnPagar} onClick={() => marcarPagado(t.id, true)}>Marcar pagado</button>)
                          : <span style={{ fontSize: 12, color: '#856404' }}>Pendiente</span>)
                      }
                    </div>
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
}
